import * as z from 'zod';

/**
 * Строковый search-параметр, который переживает разбор адреса.
 *
 * <p>Роутер разбирает значение из строки запроса по его виду, а не по схеме: `?callback=1`
 * приезжает **числом**, `?flag=true` — **булевым**, и только `?name=abc` остаётся строкой. Схема
 * `z.string()` такое значение отбраковывает, а падает при этом не параметр, а весь матч роутов –
 * человек видит ошибку вместо экрана.
 *
 * <p>Так 03.09.2026 сломалась кнопка «Перезвонить» в пуше о пропущенном звонке: она ведёт на
 * `/dashboard/chats/<id>?callback=1`, схема ждала строку, получила единицу и уронила страницу
 * чата. Внутренняя навигация тем же параметром работала – она кладёт строку, – поэтому в
 * приложении это не воспроизводилось, только по ссылке снаружи.
 *
 * <p>Приводим к строке вместо перечисления допустимых типов: потребителю нужен один тип, а
 * `z.union([z.string(), z.number()])` заставил бы каждое место сравнения помнить про оба.
 */
export const optionalSearchString = () => z.coerce.string().optional();
